"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sorted = exports.compare = exports.NAMESPACE = void 0;
exports.NAMESPACE = 'Culligan.Api.OpenApi.Order';
/**
 * UTF-16 code-unit order: the same as `Array#sort()` with no compare
 * function, and independent of the runtime locale.
 *
 * `String#localeCompare` and the default sort disagree on mixed case and
 * punctuation (`/Devices` and `/a_b` sort before `/ab` here; they do not
 * under `localeCompare`). Every deterministic list this package emits —
 * audiences, groups, operations, parity reports, error messages — uses
 * this comparator so document order cannot flip with the locale or the
 * call site.
 */
const compare = (a, b) => {
    if (a === b)
        return 0;
    return a < b ? -1 : 1;
};
exports.compare = compare;
/** A new array of `items`, ordered by {@link compare}. */
const sorted = (items) => Array.from(items).sort(exports.compare);
exports.sorted = sorted;
//# sourceMappingURL=order.js.map